<template>
  <b-modal ref="driverCompany-card-modal" @ok="driverCompanyCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.driverCompanies.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.companyName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="companyName"
          :state="isCompanyNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.codeEdrpou"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="codeEdrpou"
          :state="isCodeEdrpouValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.filia"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="filia"
          :state="isFiliaValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.unit"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="unit"
          :state="isUnitValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.fuelDepo"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelDepoId"
          :state="isFuelDepoValid"
          :options="fuelDepoOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { azkService } from "../../../../services";

export default {
  name: "CreateDriverCompanyPage",
  props: {
    fuelDepos: Array,
    driverCompanies: Array,
  },
  components: {},
  data() {
    return {
      validationErrorMessage: null,
      fuelDepoOptions: [],
      companyName: null,
      codeEdrpou: null,
      filia: null,
      unit: null,
      fuelDepoId: null,
     
      isCompanyNameValid: null,
      isCodeEdrpouValid: null,
      isFiliaValid: null,
      isUnitValid: null,
      isFuelDepoValid: null
    };
  },
  methods: {
    open() {
      this.companyName = null;
      this.codeEdrpou = null;
      this.filia = null;
      this.unit = null;
      this.fuelDepoId = null;
      
      this.validationErrorMessage = null;
      this.isCompanyNameValid = null;
      this.isCodeEdrpouValid = null;
      this.isFiliaValid = null;
      this.isUnitValid = null;
      this.isFuelDepoValid = null;
      this.fuelDepoOptions = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        this.fuelDepoOptions.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      this.$refs["driverCompany-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.companyName) {
        this.isCompanyNameValid = false;
        isValid = false;
      } else {
        this.isCompanyNameValid = null;
      }

      if (!this.codeEdrpou) {
        this.isCodeEdrpouValid = false;
        isValid = false;
      } else {
        this.isCodeEdrpouValid = null;
      }

      if (!this.filia) {
        this.isFiliaValid = false;
        isValid = false;
      } else {
        this.isFiliaValid = null;
      }

      if (!this.unit) {
        this.isUnitValid = false;
        isValid = false;
      } else {
        this.isUnitValid = null;
      }

      if (!this.fuelDepoId) {
        this.isFuelDepoValid = false;
        isValid = false;
      } else {
        this.isFuelDepoValid = null;
      }

      return isValid;
    },
    async driverCompanyCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const fuelDepoId = parseInt(this.fuelDepoId);
      const driverCompany = this.driverCompanies.find(x => x.fuelDepoId == fuelDepoId);

      const driverCompanyCard = {
        companyName: this.companyName,
        codeEdrpou: this.codeEdrpou,
        filia: this.filia,
        unit: this.unit,
        clientId: driverCompany.clientId,
        fuelDepoId: fuelDepoId
      };

      const createDriverCompanyResponse = await azkService.createCompany(driverCompanyCard);

      if (
        createDriverCompanyResponse.isSuccess &&
        createDriverCompanyResponse.data &&
        createDriverCompanyResponse.data.countInsertedRows == 1
      ) {
        this.$emit("driverCompanyCreatedSuccessEvent", this.driverCompany);
      } else {
        this.$emit("driverCompanyCreatedFailEvent");
      }
    },
  },
};
</script>
